/*
 * The browser no longer holds the import. It reads a prefix to drive the
 * column mapping, uploads the raw file in parts, and then only polls — so the
 * old MAX_PREVIEW_ROWS / MAX_CLIENT_DUPLICATE_CHECK caps are gone.  [AVP-891]
 */

/** Matches the server's MAX_UPLOAD_BYTES; over this, split the file. */
export const MAX_IMPORT_TOTAL_BYTES = 100 * 1024 * 1024;

/**
 * JSON is capped far lower than CSV because it cannot be read incrementally:
 * the browser converts it to CSV before uploading, which means the whole
 * document and its object graph are in memory at once.
 */
export const MAX_JSON_BYTES = 15 * 1024 * 1024;

/** How much of the file is read to show the header and a few sample rows. */
export const PREFIX_BYTES = 512 * 1024;

export const SAMPLE_ROWS = 50;

/** Server-declared; this is only the client's fallback before it is told. */
export const PART_BYTES = 4 * 1024 * 1024;

/** Problem rows shown in the table; the rest live in the CSV report. */
export const MAX_PROBLEM_ROWS = 1000;

export const PROBLEM_PAGE_SIZE = 50;

export const POLL_BASE_MS = 2000;

export const POLL_MAX_MS = 30000;

/** Background tabs are throttled anyway; make the slowdown deliberate. */
export const POLL_HIDDEN_MS = 10000;

export const POLL_MAX_FAILURES = 5;

/** Icons are matched and batched in the browser; the ZIP is never uploaded. */
export const MAX_ICON_ZIP_BYTES = 64 * 1024 * 1024;

export const MAX_ICONS_PER_RUN = 1000;

export const MAX_ICON_BATCH_ENTRIES = 100;

/** Encoded size, so it stays under the server's 8 MB body cap. */
export const MAX_ICON_BATCH_BYTES = 6 * 1024 * 1024;

export const IMPORT_FILE_EXTENSIONS = ['.csv', '.tsv', '.txt', '.json'];

export const CODE_ALIASES = [
  'code', 'assettypecode', 'sku', 'upc', 'gtin', 'item', 'itemcode',
  'part', 'partnumber', 'partno',
];

export const DESCRIPTION_ALIASES = [
  'description', 'assettypedescription', 'desc', 'name',
  'itemdescription', 'productdescription',
];

export const IGNORED_HEADERS = ['id', 'tenant', 'key'];

export const PROPERTY_PREFIXES = ['assettype.properties.', 'properties.', 'property.'];

export const ASSET_TYPE_PREFIX = 'assettype.';

/*
 * Kept until the wizard rewrite removes their last callers (AVP-891 WP4.5).
 * Nothing new should use these.
 */

/** @deprecated the server enforces its own row cap; the client streams. */
export const MAX_PREVIEW_ROWS = 5000;

/** @deprecated use MAX_IMPORT_TOTAL_BYTES / MAX_JSON_BYTES. */
export const MAX_IMPORT_BYTES = 5 * 1024 * 1024;

/** @deprecated the editable preview is going away. */
export const PREVIEW_PAGE_SIZE = 50;

/** @deprecated duplicates are detected server-side now. */
export const MAX_CLIENT_DUPLICATE_CHECK = 20000;
